import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, Building2Icon, CalendarDaysIcon, LandmarkIcon, MoonStarIcon, TelescopeIcon } from 'lucide-react';
export function Tomos() {
  const tomos = [['TOMO I', 'Los Orígenes de la Civilización Maya', 'El nacimiento de una cultura que transformó la historia de Mesoamérica.', LandmarkIcon], ['TOMO II', 'Las Grandes Ciudades Mayas', 'Un recorrido por los centros urbanos, sus templos y sus huellas arquitectónicas.', Building2Icon], ['TOMO III', 'Astronomía, Ciencia y Conocimiento', 'La precisión de sus calendarios y una mirada a su profundo saber científico.', TelescopeIcon], ['TOMO IV', 'Dioses, Rituales y Cosmovisión', 'Los símbolos, creencias y ceremonias que dieron forma a su universo espiritual.', MoonStarIcon], ['TOMO V', 'Los Grandes Misterios Mayas', 'Preguntas fascinantes, evidencias y teorías explicadas con contexto histórico.', CalendarDaysIcon], ['TOMO VI', 'El Legado de los Mayas', 'La vigencia de un pueblo cuya herencia continúa viva hasta nuestros días.', BookOpenIcon]];
  return <section className="bg-dark-card/45 px-5 py-24 md:py-32" data-id="element-228">
      <div className="mx-auto max-w-7xl" data-id="element-229">
        <div className="mb-14 max-w-2xl" data-id="element-230">
          <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-231">
            La biblioteca
          </p>
          <h2 className="mt-3 text-4xl font-semibold text-stone-light md:text-6xl" data-id="element-232">
            Los 6 tomos documentales
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-233">
          {tomos.map(([number, title, description, Icon], index) => <motion.article key={number as string} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="rounded-xl border border-dark-border bg-dark p-7" data-id="element-234">
              <Icon className="mb-8 h-6 w-6 text-gold-light" data-id="element-235" />
              <p className="text-xs font-bold tracking-[.16em] text-gold" data-id="element-236">
                {number}
              </p>
              <h3 className="mt-3 text-2xl font-semibold text-stone-light" data-id="element-237">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-stone" data-id="element-238">{description}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}